export enum UpdateNotificationType {
  None = 'None',
  MarkAllAsRead = 'MarkAllAsRead',
  MarkItemsAsRead = 'MarkItemsAsRead'
}
